import React from 'react';
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import iconUnlock from "../../../images/modal-icon-unlock.svg"
import iconCheck from "../../../images/modal-icon-check.svg"

const RunTrialModal = ({afterClose, link, productType}) => {

    return (
        <Modal isOpen={true} toggle={afterClose} fade={true} centered={true} size="lg" contentClassName="rounded-20">
            <ModalHeader tag="div" toggle={afterClose} className="align-items-start">
                <div className="d-flex align-content-center">
                    <img src={iconUnlock} className="pe-3"/>
                    <h1 className="modal-title text-22 text-start my-auto">
                        <FormattedMessage defaultMessage="Aktivovat zkušební verzi"/><br/>
                        <FormattedMessage defaultMessage="Škola s{nbsp}nadhledem PREMIUM" values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                    </h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12} lg={6}>
                        <p className="mt-3 text-19 ps-2 pb-4 pb-lg-2">
                            <FormattedMessage defaultMessage="Na 1 měsíc vám aktivujeme Škola s{nbsp}nadhledem PREMIUM." values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }} />
                        </p>
                    </Col>
                    {
                        productType === 'family' && <Col  xs={12} lg={6}>
                            <h2 className="text-14">
                                <FormattedMessage defaultMessage="Díky tomu získáte"/>
                            </h2>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Kompletní přehled o procvičování svých dětí."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Možnost porovnání výsledků Vašich dětí s výsledky jejich vrstevníků."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Motivaci pro Vaše děti v podobě sbírání odznaků za dobře odvedenou práci."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Adblock."/>
                                </div>
                            </div>
                        </Col>
                    }
                    {
                        productType === 'teacher' && <Col  xs={12} lg={6}>
                            <h2 className="text-14">
                                <FormattedMessage defaultMessage="Díky tomu získáte"/>
                            </h2>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Možnost zadávat domácí úkoly hromadně i jednotlivě, navíc bez nutnosti je opravovat."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Přehled o vývoji znalostí svých žáků ve svých třídách."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Anonymní srovnání výsledků žáků z Vaší třídy s výsledky jejich vrstevníků."/>
                                </div>
                            </div>
                            <div className="d-flex text-body text-14 py-2">
                                <img src={iconCheck} />

                                <div className="ps-2">
                                    <FormattedMessage defaultMessage="Adblock."/>
                                </div>
                            </div>
                        </Col>
                    }
                </Row>
            </ModalBody>
            <ModalFooter className="justify-content-center mt-3 pt-3">
                <a href={link} className="btn btn--blue btn--bolder mb-3">
                    <FormattedMessage defaultMessage="Vyzkoušet zdarma"/>
                </a>
            </ModalFooter>
        </Modal>
    );

};

RunTrialModal.propTypes = {
    afterClose: PropTypes.func.isRequired,
    link: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired
};

RunTrialModal.defaultProps = {}

export default RunTrialModal;
